module.exports = {
      id: "dislike-color-vector-usage",
      viewBox: "0 0 25 23",
      url: "img/" + "sprite.svg#dislike-color-vector-usage",
      toString: function () {
        return this.url;
      }
    }